import React from 'react'
import { Tabs, Tab, Box, Typography, IconButton, Paper, InputBase } from '@mui/material';

const BomTab = ({selectedTab,handleChange}) => {
    return (
        <Tabs
            value={selectedTab}
            onChange={handleChange}
            aria-label="customer tabs"
            sx={{
                color: '#512DA8',
                backgroundColor: '#fff',
                width: '68%',
                boxShadow: '0px -1px 0px 0px #E8E8E8 inset',
                '& .MuiTabs-indicator': {
                    backgroundColor: '#512DA8',
                },
                '& .MuiTab-root': {
                    fontSize: '16px',
                    textTransform: 'capitalize',
                    color: '#585757', // Default color for all tabs
                },
                '& .Mui-selected': {
                    fontSize: '16px',
                    textTransform: 'capitalize',
                    color: '#512DA8 !important', // Color for the selected tab
                    borderRadius: '0px',
                },
            }}
        >
            <Tab label="All Enquiries" sx={{
                color: selectedTab === 0 ? '#FFFFFF' : '#512DA8',
                borderRadius: '8px',
            }} />
            <Tab label="New Enquiry" />
            <Tab label="Quoted Enquiry" />
            <Tab label="Completed Enquiry" />
            <Tab label="Deleted Enquiry" />
        </Tabs>
    )
}

export default BomTab